export const introSteps = [
    {
      element: '#add-portfolio-btn',
      popover: {
        title: 'Create Your First Portfolio',
        description: "Click this button to start tracking your assets. You need at least one portfolio to begin.",
        side: 'bottom',
        align: 'start',
        showButtons: [] // Hide buttons to force click
      }
    }
  ];

  export const creationSteps = [
    {
        element: '#portfolio-name-input',
        popover: {
            title: 'Name Your Portfolio',
            description: "Give your portfolio a name (e.g., 'Retirement', 'My All Assets', 'Investments').",
            side: 'top',
            align: 'start'
        }
    },
    {
        element: '#include-net-worth-section',
        popover: {
            title: 'Include in Net Worth?',
            description: "The Net Worth tab tracks your total wealth. Check this to include this portfolio in your Net Worth.",
            side: 'right',
            align: 'center'
        }
    }
  ];

  export const postCreationSteps = [
    {
      element: '.portfolio-name-link',
      popover: {
        title: 'Open Your Portfolio',
        description: "Click on your portfolio name to open it and start adding transactions. This will take you to the transactions page.",
        side: 'right',
        align: 'start'
      }
    }
  ];

  export const finalOnboardingSteps = [
    {
      element: '#nav-net-worth',
      popover: {
        title: 'Track Your Net Worth',
        description: "See your total wealth history over time. This aggregates all your portfolios (except Watchlists) into a single performance chart.",
        side: 'bottom',
        align: 'start'
      }
    },
    {
      element: '#nav-custom-symbols',
      popover: {
        title: 'Track Anything',
        description: "Can't find an asset? Click here to create Personal Assets for things like Real Estate, Private Equity, or rare collectibles. You can then add these assets to any portfolio.",
        side: 'right',
        align: 'start'
      }
    },
    {
      element: '#global-symbol-search',
      popover: {
        title: 'Build Your View',
        description: "Search for assets here. Tip: Try adding different types of assets (e.g., US Stocks, Crypto, Gold) to generate a diverse 'Asset Allocation' chart in your analysis.",
        side: 'bottom',
        align: 'start'
      }
    },
    {
      element: '#portfolio-analysis-card',
      popover: {
        title: 'Deep Dive Analysis',
        description: "Once you add transactions, check this section. It calculates your Realized/Unrealized gains and visualizes your diversity.",
        side: 'top',
        align: 'start'
      }
    }
  ];
  
  export const welcomeStep = {
    popover: {
      title: 'Welcome to TrackFolio!',
      description: "Let's take a quick tour to help you get the most out of your wealth tracking."
    }
  };
  
  export const portfolioTourSteps = [
    {
      element: '#add-transaction-btn',
      popover: {
        title: 'Add Your First Transaction',
        description: "Click here to add assets to this portfolio. You can record Buys, Sells, and build your history.",
        side: 'top',
        align: 'end'
      }
    }
  ];

  export const clickAddForSecondStep = [
    {
      element: '#add-transaction-btn',
      popover: {
        title: 'Keep Going!',
        description: "Great start! Now let's add a different asset (Gold) to see how diversification looks.",
        side: 'top',
        align: 'end'
      }
    }
  ];

  export const clickAddForSellStep = [
    {
      element: '#add-transaction-btn',
      popover: {
        title: 'Record a Sale',
        description: "Now let's simulate selling some of your Gold. Click here to record a 'Sell' transaction.",
        side: 'top',
        align: 'end'
      }
    }
  ];

  export const clickAddForCustomStep = [
    {
      element: '#add-transaction-btn',
      popover: {
        title: 'Track Unique Assets',
        description: "Finally, let's try to add something unique like a 'Rolex Watch' that isn't in the standard database.",
        side: 'top',
        align: 'end'
      }
    }
  ];

  export const firstTransactionSteps = [
    {
      element: '#transaction-symbol-search',
      disableActiveInteraction: false, // Allow typing in search bar
      popover: {
        title: 'Search for an Asset',
        description: "Type 'AAPL' here to search for Apple stock. This search finds stocks, crypto, and other assets.",
        side: 'top',
        align: 'start'
      }
    },
    {
      element: '#transaction-buy-btn',
      popover: {
        title: 'Select Buy',
        description: "Click 'Buy' when you're purchasing an asset. Use 'Sell' when you're selling it.",
        side: 'right',
        align: 'center'
      }
    },
    {
      element: '#transaction-quantity-input',
      popover: {
        title: 'Enter Quantity',
        description: "This is how many shares/units you bought or sold. For example, if you bought 10 shares of AAPL, enter '10'.",
        side: 'top',
        align: 'start'
      }
    },
    {
      element: '#transaction-price-input',
      popover: {
        title: 'Enter Price Per Unit',
        description: "This is the price for a single share/unit. For example, if AAPL was $150 per share, enter '150'.",
        side: 'top',
        align: 'start'
      }
    },
    {
      element: '#transaction-date-input',
      popover: {
        title: 'Select Date',
        description: "Choose the date when this transaction occurred. This helps track your investment history over time.",
        side: 'top',
        align: 'start'
      }
    }
  ];

  export const secondTransactionSteps = [
    {
      element: '#transaction-symbol-search',
      disableActiveInteraction: false,
      popover: {
        title: 'Add Gold to Your Portfolio',
        description: "Now let's diversify! Type 'XAUUSD' to search for gold. You already know how to fill in the rest!",
        side: 'top',
        align: 'start'
      }
    },
    {
      // After selecting Gold, show a quick non-blocking reminder (no highlight)
      popover: {
        title: 'Nice — add the details',
        description: "Now just enter quantity, price, and date, then add the transaction.",
      }
    }
  ];

  export const sellTransactionSteps = [
    {
      element: '#transaction-symbol-search',
      disableActiveInteraction: false,
      popover: {
        title: 'Sell Some Gold',
        description: "Search for 'XAUUSD' again - this time we'll record a sale.",
        side: 'top',
        align: 'start'
      }
    },
    {
      element: '#transaction-sell-btn',
      popover: {
        title: 'Click Sell This Time! 📉',
        description: "This is the key difference - click 'Sell' instead of 'Buy' when you're selling an asset. Enter half of what you bought to simulate a partial sale.",
        side: 'right',
        align: 'center'
      }
    }
  ];

  export const customSymbolSearchSteps = [
    {
      element: '#transaction-symbol-search',
      disableActiveInteraction: false,
      popover: {
        title: 'Search for Personal Asset',
        description: "Try searching for 'rolex watch'. You'll see that this asset doesn't exist in our database.",
        side: 'top',
        align: 'start'
      }
    }
  ];

  export const customSymbolCreationSteps = [
    {
      element: '#add-custom-symbol-btn',
      popover: {
        title: 'Create Personal Asset',
        description: "Click here to create a new asset for items that don't exist in our database, like your Rolex watch!",
        side: 'bottom',
        align: 'start',
        showButtons: ['close', 'next'] // Show close and next/done buttons
      }
    }
  ];

  export const customSymbolFormSteps = [
    {
      element: '#custom-symbol-input',
      popover: {
        title: 'Enter a Ticker',
        description: "This is a short code to identify your asset. For a Rolex, you could use 'ROLEX' or 'WATCH1'. Keep it simple and memorable!",
        side: 'top',
        align: 'start'
      }
    },
    {
      element: '#custom-symbol-name-input',
      popover: {
        title: 'Full Name',
        description: "Enter a descriptive name like 'Rolex Submariner Watch'. This helps you identify the asset later.",
        side: 'top',
        align: 'start'
      }
    },
    {
      element: '#custom-symbol-price-input',
      popover: {
        title: 'Current Value',
        description: "Enter the current market value of your asset in USD. You can update this anytime as the value changes.",
        side: 'top',
        align: 'start'
      }
    },
    {
      element: '#custom-symbol-type-select',
      popover: {
        title: 'Asset Type',
        description: "You can select the type of asset you are creating. This helps categorize your portfolio.",
        side: 'top',
        align: 'start'
      }
    }
  ];

  export const useCustomSymbolSteps = [
    {
      element: '#add-transaction-btn',
      popover: {
        title: 'Use Your Personal Asset!',
        description: "Now let's add your new personal asset to your portfolio. Click here to create a transaction with it!",
        side: 'top',
        align: 'end'
      }
    }
  ];

  export const customSymbolTransactionSteps = [
    {
      element: '#transaction-symbol-search',
      disableActiveInteraction: false,
      popover: {
        title: 'Find Your Personal Asset',
        description: "Search for the personal asset you just created (e.g., 'ROLEX'). It will appear in the search results!",
        side: 'top',
        align: 'start'
      }
    },
    {
      element: '#transaction-buy-btn',
      popover: {
        title: 'Record the Purchase',
        description: "Select 'Buy' to record when you acquired this asset.",
        side: 'right',
        align: 'center'
      }
    },
    {
      element: '#transaction-quantity-input',
      popover: {
        title: 'How Many?',
        description: "Enter the quantity. For unique items like a watch, this is usually '1'.",
        side: 'top',
        align: 'start'
      }
    },
    {
      element: '#transaction-price-input',
      popover: {
        title: 'Purchase Price',
        description: "Enter what you paid for it. This helps track your gains/losses over time. After saving, we'll show you the analysis tools!",
        side: 'top',
        align: 'start'
      }
    }
  ];

  export const analysisButtonStep = [
    {
      element: '#toggle-analysis-btn',
      popover: {
        title: 'View Portfolio Analysis 📊',
        description: "Click this button to reveal detailed insights about your portfolio performance!",
        side: 'bottom',
        align: 'start',
        showButtons: [] // Force user to click the actual button
      }
    }
  ];

  export const analysisContentSteps = [
    {
      element: '#portfolio-analysis-card',
      popover: {
        title: 'Your Portfolio Analysis',
        description: "This powerful section shows your Asset Allocation pie chart, Realized vs Unrealized gains, and overall portfolio performance. As you add more diverse assets, you'll see a beautiful breakdown of your wealth distribution!",
        side: 'top',
        align: 'center'
      }
    },
    {
      popover: {
        title: 'Congratulations! 🎉',
        description: "You've completed the main TrackFolio tour! You now know how to:\n\n✅ Create portfolios\n✅ Add transactions (Buy/Sell)\n✅ Track different asset types\n✅ Create personal assets\n✅ Analyze your portfolio\n\n💡 Tip: Visit the Net Worth and Liabilities tabs to explore more features!",
      }
    }
  ];

  // Net Worth page tour - shown when user first visits
  export const netWorthTourSteps = [
    {
      element: '.net-worth-page',
      popover: {
        title: 'Welcome to Net Worth! 📊',
        description: "This is your financial command center. Here you can see the big picture of your wealth.",
        side: 'bottom',
        align: 'center'
      }
    },
    {
      element: '#net-worth-summary-cards',
      popover: {
        title: 'Your Financial Summary',
        description: "These cards show your Total Assets, Total Liabilities, and Net Worth at a glance. Net Worth = Assets - Liabilities.",
        side: 'bottom',
        align: 'center'
      }
    },
    {
      element: '#assets-vs-liabilities-bar',
      popover: {
        title: 'Assets vs Liabilities',
        description: "This bar visualizes the proportion of your assets compared to your liabilities. The greener, the healthier!",
        side: 'top',
        align: 'center'
      }
    },
    {
      element: '#net-worth-history-chart',
      popover: {
        title: 'Track Your Progress',
        description: "Watch your net worth grow over time with this historical chart. It updates as you add transactions and make payments.",
        side: 'top',
        align: 'center'
      }
    }
  ];

  // Liabilities page tour - shown when user first visits
  export const liabilitiesTourSteps = [
    {
      element: '.liabilities-page',
      popover: {
        title: 'Welcome to Liabilities! 💳',
        description: "Track all your debts here - mortgages, car loans, credit cards, and more. Understanding your liabilities is key to building wealth.",
        side: 'bottom',
        align: 'center'
      }
    },
    {
      element: '#add-liability-btn',
      popover: {
        title: 'Add Your Debts',
        description: "Click here to add a new liability. You can track mortgages, auto loans, student loans, credit cards, and custom debts.",
        side: 'bottom',
        align: 'start'
      }
    },
    {
      element: '#liabilities-summary-cards',
      popover: {
        title: 'Debt Overview',
        description: "See your total debt, monthly payments, and track your progress toward becoming debt-free.",
        side: 'bottom',
        align: 'center'
      }
    },
    {
      popover: {
        title: 'Smart Debt Tracking 🎯',
        description: "TrackFolio automatically calculates:\n\n✅ Interest vs Principal breakdown\n✅ Remaining balance over time\n✅ Payment progress\n✅ Impact on your Net Worth\n\nStart by adding your first liability!",
      }
    }
  ];
  